import { getApi, putApi, postApi, deleteApi } from "./apiHelper";
import { userList, userDetail, userUpdate, plansList, plansListPost, plansAdd, planUpdate, planDelete, plansCurrent, plansAvailable, plansAssign, plansChange } from "../settings/apiConfig";

// =========================================================
// USER MANAGEMENT APIs
// =========================================================

export const getAllUsers = (page = 1, limit = 50, search = '') => {
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    return getApi(`${userList}?page=${page}&limit=${limit}${searchParam}`);
};

export const getUserById = (userId) => {
    return getApi(`${userDetail}/${userId}`);
};

export const updateUserProfile = (userId, body) => {
    return putApi(`/api/users/${userId}`, body);
};

export const updateUserRole = (userId, newRole) => {
    return putApi('/api/users/role', { user_id: userId, role: newRole });
};

export const deleteUser = (userId) => {
    return deleteApi(`${userDetail}/${userId}`);
};

// =========================================================
// PLAN MANAGEMENT APIs
// =========================================================

export const getAllPlans = (page = 1, limit = 50) => {
    return postApi(plansListPost, {
        pagination: { page, limit },
        sort: [{ field: "created_at", direction: "desc" }],
        filter: [{ field: "is_deleted", value: false, op: "=", join: "AND" }]
    });
};

export const getPlanById = (planId) => {
    return getApi(`${plansList}/${planId}`);
};

export const updatePlan = (planId, data) => {
    return putApi(`${planUpdate}/${planId}`, data);
};

export const createPlan = (data) => {
    return postApi(plansAdd, data);
};

export const deletePlan = (planId) => {
    return deleteApi(`${planDelete}/${planId}`);
};

export const getCurrentPlan = () => {
    return getApi(plansCurrent);
};

export const getAvailablePlans = () => {
    return getApi(plansAvailable);
};

export const assignPlan = (data) => {
    return postApi(plansAssign, data);
};

export const changePlan = (data) => {
    return postApi(plansChange, data);
};
